import React from "react";
import DonationForm from "../layouts/DonationForm";
import Footer from "../layouts/Footer";
import Navbar from "../layouts/Navbar";

export default function Donate() {
  return (
    <>
      <Navbar />
      <DonationForm />
      <Footer />
    </>
  );
}
